const DEFAULT_INTEGRATION_CONFIG_OCR_AUTOMATIC_PROCESS = 'true';
export const INTEGRATION_CONFIG_OCR_AUTOMATIC_PROCESS = 'automaticProcess';

export const ocrDefaultConfigurations = {
  [INTEGRATION_CONFIG_OCR_AUTOMATIC_PROCESS]: DEFAULT_INTEGRATION_CONFIG_OCR_AUTOMATIC_PROCESS,
};
